import React from 'react';
import { Modal, message } from 'antd';
import { useDelete } from '@refinedev/core';
import { type BaseRecord } from '@refinedev/core';
import { SmartDataTableProps } from '../types';

interface DeleteComponentProps {
  api: SmartDataTableProps['api'];
  record: BaseRecord | null;
  rowKey?: string;
  onSuccess?: (record: BaseRecord) => void;
}

export const DeleteComponent: React.FC<DeleteComponentProps> = ({
  api,
  record,
  rowKey = 'id',
  onSuccess,
}) => {
  // Delete using Refine's useDelete
  const { mutate: deleteRecord } = useDelete();

  const handleDelete = (recordToDelete: BaseRecord) => {
    Modal.confirm({
      title: 'Delete Record',
      content: 'Are you sure you want to delete this record?',
      okText: 'Delete',
      okType: 'danger',
      cancelText: 'Cancel',
      onOk: () => {
        deleteRecord(
          { resource: api.resource, id: recordToDelete[rowKey] },
          {
            onSuccess: () => {
              message.success('Record deleted successfully');
              onSuccess?.(recordToDelete);
            },
            onError: () => {
              message.error('Failed to delete record');
            },
          }
        );
      },
    });
  };

  // This component doesn't render anything visible
  // It just provides the delete functionality
  React.useEffect(() => {
    if (record) {
      handleDelete(record);
    }
  }, [record]);

  return null;
};
